import { postRequest } from '../../../../../../api/http-v2';

/**
 * Pauses a single listing, initiated by the host/owner.
 * * @param {string} listingId The ID of the listing to pause.
 * @returns {Promise<object>} A promise that resolves with the API confirmation object, including the count of listings successfully set to PAUSED (e.g., {count: 1}).
 */

export async function hostPauseListing (listingId) {
  const endpoint = `/v2/spaces-v2/listings/${listingId}/pause`;
  const body = {
    mode: 'single',
    listing_id: listingId
  };

  return postRequest({ endpoint, body, options: { useAccessToken: true } });
}

/**
 * Pauses all active listings belonging to a space, initiated by the host/owner.
 * @param {string} spaceId The ID of the space containing the listings to pause.
 * @returns {Promise<object>} A promise that resolves with the API confirmation object, including the count of listings successfully set to PAUSED (e.g., {count: 3}).
 */
export async function hostPauseAllListings (spaceId) {
  const endpoint = `/v2/spaces-v2/spaces/${spaceId}/listings/pause-all`;

  const body = {
    mode: 'all',
    space_id: spaceId
  };

  return postRequest({ endpoint, body, options: { useAccessToken: true } });
}

/**
 * UnPauses a single listing, initiated by the host/owner.
 * * @param {string} listingId The ID of the listing to pause.
 * @returns {Promise<object>} A promise that resolves with the API confirmation object, including the count of listings successfully set to PAUSED (e.g., {count: 1}).
 */

export async function hostUnPauseListing (listingId) {
  const endpoint = `/v2/spaces-v2/listings/${listingId}/unpause`;
  const body = {
    mode: 'single',
    listing_id: listingId
  };

  return postRequest({ endpoint, body, options: { useAccessToken: true } });
}

/**
 * UnPauses all active listings belonging to a space, initiated by the host/owner.
 * @param {string} spaceId The ID of the space containing the listings to pause.
 * @returns {Promise<object>} A promise that resolves with the API confirmation object, including the count of listings successfully set to PAUSED (e.g., {count: 3}).
 */
export async function hostUnPauseAllListings (spaceId) {
  const endpoint = `/v2/spaces-v2/spaces/${spaceId}/listings/unpause-all`;

  const body = {
    mode: 'all',
    space_id: spaceId
  };

  return postRequest({ endpoint, body, options: { useAccessToken: true } });
}
